import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'filterReset',
    position: [
        ButtonPosition.tabEvent,
        ButtonPosition.dialog,
        ButtonPosition.blockButton,
    ],
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options = {} } = buttonConfig;
        const { _bindFilter } = options;
        function reloadOneFilter(id) {
            if (typeof id === 'string') {
                const filter = _context.$(id);
                filter?.reset?.();
            }
        }
        if (_bindFilter && _context) {
            if (Array.isArray(_bindFilter)) {
                _bindFilter.forEach((item) => {
                    reloadOneFilter(item);
                });
            }
            else {
                reloadOneFilter(_bindFilter);
            }
        }
    },
};
